import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { FamilyAcceptInviteDialogProps } from './FamilyAcceptInviteDialog.types';

export const openFamilyAcceptInviteModal = ({ onClose, ...data }: FamilyAcceptInviteDialogProps) =>
    openPopupHelper({ popupName: popupNames.FAMILY_ACCEPT_INVITE, data, onClose });
